import Ajv from 'ajv'
import addFormats from 'ajv-formats'

const ajv = new Ajv( {
  strict: true,
  timestamp: 'date',
  allErrors: true
} )

addFormats( ajv )

ajv.addVocabulary( [
  'pk',
  'encode',
  'decode'
] )

export default ajv
